import { useTranslation } from 'react-i18next'

import DialogNames from '~/constants/DialogNames'
import {
  PrescriptionDeclineReasonName,
  PrescriptionDeclineReasonType,
} from '~/constants/PrescriptionWorkflow'
import { getSwapProductTrackingData } from '~/constants/swapProductAnalytics'
import { trackEvent, TrackingEvent } from '~/utils/trackingProvider'
import useDialog from '~/utils/useDialog'

import type { PrescriptionActionContextType } from '../../PrescriptionContext'
import { KibButtonWithMenu } from './KibButtonWithMenu'

export interface PrescriptionDeclineActionChirpProps {
  className?: string
  disabled?: boolean
  loading?: boolean
  onDecline: PrescriptionActionContextType['onDecline']
  prescriptionForTracking: PrescriptionActionContextType['prescriptionForTracking']
}

const PrescriptionDeclineActionChirp = ({
  className,
  disabled,
  loading,
  onDecline,
  prescriptionForTracking,
}: PrescriptionDeclineActionChirpProps) => {
  const { t } = useTranslation(['Common'])
  const [openDialog] = useDialog(DialogNames.PRESCRIPTION_DECLINE_REASON_CHIRP)

  const handleDecline = (declineReason: string) => {
    const reasonType = declineReason as PrescriptionDeclineReasonType

    if (reasonType === PrescriptionDeclineReasonType.PET_NEEDS_TO_BE_SEEN) {
      trackEvent(
        TrackingEvent.DECLINE_PET_NEEDS_SEEN,
        getSwapProductTrackingData(
          'DECLINE_PET_NEEDS_SEEN',
          prescriptionForTracking,
        ),
      )
    }

    if (reasonType === PrescriptionDeclineReasonType.WRONG_PRODUCT) {
      trackEvent(
        TrackingEvent.DECLINE_WRONG_PRODUCT,
        getSwapProductTrackingData(
          'DECLINE_WRONG_PRODUCT',
          prescriptionForTracking,
        ),
      )
    }

    if (reasonType === PrescriptionDeclineReasonType.WRONG_PET) {
      trackEvent(
        TrackingEvent.DECLINE_WRONG_PET,
        getSwapProductTrackingData(
          'DECLINE_WRONG_PET',
          prescriptionForTracking,
        ),
      )
    }

    if (reasonType === PrescriptionDeclineReasonType.NOT_A_CLINIC_PATIENT) {
      trackEvent(
        TrackingEvent.DECLINE_NOT_A_CLINIC_PATIENT,
        getSwapProductTrackingData(
          'DECLINE_NOT_A_CLINIC_PATIENT',
          prescriptionForTracking,
        ),
      )
    }

    if (reasonType === PrescriptionDeclineReasonType.OTHER) {
      openDialog({ onDecline, prescriptionForTracking })
    } else {
      onDecline(PrescriptionDeclineReasonName[reasonType])
    }
  }

  return (
    <KibButtonWithMenu
      buttonText={t('Common:DECLINE_ACTION')}
      className={className}
      disabled={disabled}
      loading={loading}
      name="prescription-decline"
      optionsDisplayMap={PrescriptionDeclineReasonName}
      optionsValueMap={PrescriptionDeclineReasonType}
      onSelectOption={handleDecline}
    />
  )
}

export default PrescriptionDeclineActionChirp
